import { StackScrollTool } from "@cornerstonejs/tools";
import React, { useContext, useState } from "react";
import { HIDE_TOOL_SMALL_SCREEN, VIEWPORT_TOOLS, HP_VIEWPORT_ALIGNMENT, SYNC_MODES } from "../../../../constants/Constants";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import {
  FlipHorizontally,
  FlipVertically,
  originalResolution,
  reset,
  setInvert,
  setRotation,
  setStackPosition,
} from "../../helpers/CornerstoneViewportService";
import GetToolSVG from "../Tools/ToolComponents/GetToolSVG";
import { useTranslation } from "react-i18next";
import {
  disableStackScrollSync,
  enableStackScrollSync,
} from "../../helpers/StackScrollSyncService";
import { logAmplitudeEventWithUsernameAndRole } from "../../../../helpers/Amplitude";
import userContext from "../../../../context/users/UserContext";
import $ from "jquery";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import ThumbnailContext from "../../../../context/studyviewer/ThumbnailContext";
import { getBasicViewerToolShortcutLabel } from "../../helpers/basicViewerToolShortcuts";
import ToolbarMoreMenuRow from "./ToolbarMoreMenuRow";

const DropDownToolElement = ({ tool, setShowDropDown, hideSyncSubmenu, hideSpineSubmenu }) => {
  const { t } = useTranslation();
  const [hovered, setHovered] = useState(false);
  const [showSyncModes, setShowSyncModes] = useState(false);
  const {
    activeTool,
    setActiveTool,
    previousActiveTool,
    setPreviousActiveTool,
    activeViewportIndex,
    setIsSynchronizedEnabled,
    isSynchronizedEnabled,
    setIsCineEnabled,
    isCineEnabled,
    annotationData,
    annotationDataAI,
    addedAnnotation,
    setIsReferenceLinesEnabled,
    isReferenceLinesEnabled,
    setIsReferenceLineActivated,
    boundingBoxMode,
    setBoundingBoxMode,
    isCropEnable, setIsCropEnable,
    syncMode,
    setSyncMode,
    viewportSeriesData,
    linkedViewports,
    setLinkedViewports,
    isSpineLabellingActive,
    setIsSpineLabellingActive,
    spineLabels,
    setSpineLabels,
    setSpinePhase,
  } = useContext(ViewportContext);

  const {maskImages, setMaskImages} = useContext(studyviewerContext);
const {activeThumbnailIndex} = useContext(ThumbnailContext);

  const { username } = useContext(userContext);

  const changeActiveTool = (tool) => {
    const isBBMode = boundingBoxMode;
    const isCropMode =  isCropEnable;

    setIsCropEnable(false);
    setBoundingBoxMode(false);
    setShowDropDown(false);
    if ((!isBBMode && !isCropMode )&& activeTool === tool.key) {
      setPreviousActiveTool(activeTool);
      setActiveTool(StackScrollTool.toolName);
    } else {
      setPreviousActiveTool(activeTool);
      setActiveTool(tool.key);
      if (tool.isEvent) {
        logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
      }
    }
  };

  const handleMouseOver = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const handleViewportClickTool = async (tool) => {
    setShowDropDown(false);
    switch (tool.key) {
      case "Invert":
        await setInvert(activeViewportIndex);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "RotateRight":
        await setRotation(activeViewportIndex, 90);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "RotateLeft":
        await setRotation(activeViewportIndex, -90);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "FlipVertical":
        await FlipVertically(activeViewportIndex);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "FlipHorizontal":
        await FlipHorizontally(activeViewportIndex);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "AlignLeft":
        await setStackPosition(activeViewportIndex, HP_VIEWPORT_ALIGNMENT.LEFT);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "AlignRight":
        await setStackPosition(activeViewportIndex, HP_VIEWPORT_ALIGNMENT.RIGHT);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "AlignCenter":
        await setStackPosition(activeViewportIndex, HP_VIEWPORT_ALIGNMENT.CENTER);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "Reset":
        // await originalResolution(activeViewportIndex);
        await reset(activeViewportIndex, annotationData, annotationDataAI, addedAnnotation, false,maskImages, activeThumbnailIndex);
         setMaskImages(maskImages);
        if (spineLabels.length > 0) {
          setSpineLabels([]);
          setSpinePhase("select");
        }
        document.dispatchEvent(new Event("resetImageEnhancement"));
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "Synchronize":
        if (!isSynchronizedEnabled) {
          const defaultMode = SYNC_MODES.AUTOMATIC;
          setSyncMode(defaultMode);
          if (linkedViewports.length > 0) {
            setLinkedViewports([]);
          }
          enableStackScrollSync(
            activeViewportIndex,
            defaultMode,
            viewportSeriesData,
            null
          );
          if (tool.isEvent) {
            logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
          }
        } else {
          disableStackScrollSync();
        }
        
        setIsSynchronizedEnabled(!isSynchronizedEnabled);

        return;
      case "CINE":
        setIsCineEnabled(!isCineEnabled);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "ReferenceLines":
        setIsReferenceLineActivated(!setIsReferenceLineActivated);
        setIsReferenceLinesEnabled(!isReferenceLinesEnabled);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "SpineLabelling":
        setIsSpineLabellingActive(true);
        break;
      default:
        break;
    }
    const viewportContainer = $(`#viewport-box-${activeViewportIndex}`);
    viewportContainer.addClass("blinking");
    setTimeout(() => {
      viewportContainer.removeClass("blinking");
    }, 1000);
  };

  const shortcutLabel = getBasicViewerToolShortcutLabel(tool.key);

  if (!VIEWPORT_TOOLS.includes(tool.key)) {
    return (
      <ToolbarMoreMenuRow
        className={HIDE_TOOL_SMALL_SCREEN?.includes(tool.key) ? "show-hidden-tools" : ""}
        label={t(tool.name)}
        shortcut={shortcutLabel}
        onClick={() => changeActiveTool(tool)}
        onMouseOver={handleMouseOver}
        onMouseLeave={handleMouseLeave}
      >
        <div className="highlight-tool">
          <GetToolSVG toolName={tool.key} hovered={hovered} />
        </div>
       </ToolbarMoreMenuRow>
    );
  } else if (tool.key === "Synchronize") {
    const syncModeItems = [
      { mode: SYNC_MODES.DISABLED, labelKey: "viewer.tools.disabled-sync", fallback: "Disabled" },
      { mode: SYNC_MODES.MANUAL, labelKey: "viewer.tools.manual-sync", fallback: "Manual" },
      { mode: SYNC_MODES.AUTOMATIC, labelKey: "viewer.tools.auto-sync", fallback: "Automatic" },
      { mode: SYNC_MODES.DISTANCE, labelKey: "viewer.tools.distance-sync", fallback: "Distance" },
    ];

    const handleSyncModeChange = (mode) => {
      if (mode === SYNC_MODES.DISABLED) {
        disableStackScrollSync();
        setIsSynchronizedEnabled(false);
        setSyncMode(SYNC_MODES.DISABLED);
      } else {
        const shouldClearManualLinks = mode === SYNC_MODES.AUTOMATIC && linkedViewports.length > 0;
        const nextLinkedViewports = shouldClearManualLinks ? [] : linkedViewports;
        if (shouldClearManualLinks) {
          setLinkedViewports([]);
        }

        setSyncMode(mode);
        disableStackScrollSync();
        enableStackScrollSync(
          activeViewportIndex,
          mode,
          viewportSeriesData,
          nextLinkedViewports.length > 0 ? nextLinkedViewports : null
        );
        setIsSynchronizedEnabled(true);
      }
    };

    if (hideSyncSubmenu) {
      // Render without inline submenu — flyout is handled by parent ToolDropDown
      return (
        <ToolbarMoreMenuRow
          className={HIDE_TOOL_SMALL_SCREEN?.includes(tool.key) ? "show-hidden-tools" : ""}
          label={t(tool.name)}
          shortcut="▶"
          onClick={() => handleViewportClickTool(tool)}
          onMouseOver={handleMouseOver}
          onMouseLeave={handleMouseLeave}
        >
          <div className="highlight-tool">
            <GetToolSVG toolName={tool.key} hovered={hovered} />
          </div>
        </ToolbarMoreMenuRow>
      );
    }

    return (
      <>
        <div
          style={{ position: "relative" }}
          className={HIDE_TOOL_SMALL_SCREEN?.includes(tool.key) ? "show-hidden-tools" : ""}
          onMouseEnter={() => { setHovered(true); setShowSyncModes(true); }}
          onMouseLeave={() => { setHovered(false); setShowSyncModes(false); }}
        >
          <ToolbarMoreMenuRow
            label={t(tool.name)}
            shortcut="\u25B6"
            onClick={() => handleViewportClickTool(tool)}
          >
            <div className="highlight-tool">
              <GetToolSVG toolName={tool.key} hovered={hovered} />
            </div>
          </ToolbarMoreMenuRow>

          {/* Flyout sub-menu to the right */}
          {showSyncModes && (
            <div
              className="viewer-tool-more-dropdown"
              style={{
                position: "absolute",
                left: "100%",
                top: 0,
                display: "flex",
                flexDirection: "column",
                minWidth: "140px",
                padding: "6px 0",
                borderRadius: "5px",
                boxShadow:
                  "0px 0.6px 1.8px rgba(0, 0, 0, 0.1), 0px 3.2px 7.2px rgba(0, 0, 0, 0.13)",
                zIndex: 10000,
              }}
            >
              {syncModeItems.map(({ mode, labelKey, fallback }) => {
                const isSelected = mode === SYNC_MODES.DISABLED
                  ? !isSynchronizedEnabled
                  : isSynchronizedEnabled && syncMode === mode;
                return (
                  <div
                    key={mode}
                    className="stack-scroll-dropdown-elements"
                    onClick={() => handleSyncModeChange(mode)}
                    style={{
                      justifyContent: "space-between",
                      gap: "10px",
                      cursor: "pointer",
                      padding: "0 12px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <span>{t(labelKey, fallback)}</span>
                    <span
                      style={{
                        display: "inline-block",
                        width: "10px",
                        height: "10px",
                        borderRadius: "50%",
                        backgroundColor: isSelected ? "#0078d4" : "#585858",
                        border: isSelected ? "none" : "1px solid #888",
                        flexShrink: 0,
                      }}
                    />
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </>
    );
  } else if (tool.key === "SpineLabelling") {
    return (
      <ToolbarMoreMenuRow
        className={HIDE_TOOL_SMALL_SCREEN?.includes(tool.key) ? "show-hidden-tools" : ""}
        label={t(tool.name)}
        shortcut="▶"
        onClick={() => handleViewportClickTool(tool)}
        onMouseOver={handleMouseOver}
        onMouseLeave={handleMouseLeave}
      >
        <div className="highlight-tool">
          <GetToolSVG toolName={tool.key} hovered={hovered} />
        </div>
      </ToolbarMoreMenuRow>
    );
  } else {
    return (
      <ToolbarMoreMenuRow
        className={HIDE_TOOL_SMALL_SCREEN?.includes(tool.key) ? "show-hidden-tools" : ""}
        label={t(tool.name)}
        shortcut={shortcutLabel}
        onClick={() => handleViewportClickTool(tool)}
        onMouseOver={handleMouseOver}
        onMouseLeave={handleMouseLeave}
      >
        <div className="highlight-tool">
          <GetToolSVG toolName={tool.key} hovered={hovered} />
        </div>
      </ToolbarMoreMenuRow>
    );
  }

  return (
    <ToolbarMoreMenuRow
      className={HIDE_TOOL_SMALL_SCREEN?.includes(tool.key) ? "show-hidden-tools" : ""}
      label={t(tool.name)}
      shortcut={shortcutLabel}
      onClick={() => handleViewportClickTool(tool)}
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
    >
      <div className="highlight-tool">
        <GetToolSVG toolName={tool.key} hovered={hovered} />
      </div>
    </ToolbarMoreMenuRow>
  );
};

export default DropDownToolElement;
